/* Magic UI Lens + Magic Card patterns, adapted to native Shopify DOM controls.
   References: https://magicui.design/docs/components/lens and /magic-card. */
(function () {
  'use strict';
  var reduce = matchMedia('(prefers-reduced-motion: reduce)');
  var fine = matchMedia('(hover: hover) and (pointer: fine)');
  document.querySelectorAll('[data-ml-card], .usp-row li, .pdp-proof, .tier').forEach(function (card) {
    card.addEventListener('pointermove', function (event) {
      if (reduce.matches || !fine.matches) return;
      var box = card.getBoundingClientRect();
      card.style.setProperty('--ml-px', (event.clientX - box.left) + 'px');
      card.style.setProperty('--ml-py', (event.clientY - box.top) + 'px');
    });
    card.addEventListener('pointerleave', function () { card.style.removeProperty('--ml-px'); card.style.removeProperty('--ml-py'); });
  });
  document.querySelectorAll('.ml-inspect').forEach(function (button) {
    button.setAttribute('role', 'button'); button.setAttribute('aria-pressed', 'false');
    var x = 50, y = 30, pinned = false;
    function position() { button.style.setProperty('--ml-x', x + '%'); button.style.setProperty('--ml-y', y + '%'); }
    function active(on) { button.setAttribute('aria-pressed', String(on)); }
    position();
    button.addEventListener('click', function (event) {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
      event.preventDefault(); pinned = !pinned; active(pinned);
    });
    button.addEventListener('pointerenter', function () { if (fine.matches && !reduce.matches) active(true); });
    button.addEventListener('pointerleave', function () { if (!pinned) active(false); });
    button.addEventListener('pointermove', function (event) {
      if (!fine.matches || reduce.matches) return;
      var box = button.getBoundingClientRect();
      x = Math.max(5, Math.min(95, (event.clientX - box.left) / box.width * 100));
      y = Math.max(5, Math.min(95, (event.clientY - box.top) / box.height * 100)); position();
    });
    button.addEventListener('keydown', function (event) {
      if (event.key === ' ') { event.preventDefault(); button.click(); return; }
      if (event.key === 'Escape') { pinned = false; active(false); return; }
      if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
      event.preventDefault(); pinned = true; active(true);
      x = Math.max(5, Math.min(95, x + (event.key === 'ArrowRight' ? 10 : event.key === 'ArrowLeft' ? -10 : 0)));
      y = Math.max(5, Math.min(95, y + (event.key === 'ArrowDown' ? 10 : event.key === 'ArrowUp' ? -10 : 0))); position();
    });
    button.addEventListener('blur', function () { pinned = false; active(false); });
  });
})();
